import Point from '../../Utility/Point';
import Renderable from '../Renderable';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import ObservablePoint from '../../Utility/ObservablePoint';
import Sprite from '../../Prototype/Sprite';
import { Texture } from 'pixi.js';

export default class SpriteComponent extends Renderable<PIXI.Sprite, Sprite> {
    private _texture: string;

    get texture(): string {
        return this._texture;
    }

    set texture(value: string) {
        if (this.gameObject && !this.gameObject.destroyed) {
            this._texture = value;
    
            this.container.texture = PIXIRenderer.getTexture(value);
        } else {
            console.warn(`Cannot set value after gameObject has been destroyed: ${value}`)
        }
    }

    public forceSetPIXITexture(_texture: Texture, _name: string): void {
        this.container.texture = _texture;
        this._texture = _name;
    }

    get anchor(): Point | ObservablePoint {
        return this.container.anchor as Point | ObservablePoint;
    }

    set anchor(value: Point | ObservablePoint) {
        this.container.anchor.set(value.x, value.y);
    }

    get width(): number {
        return this.container.width;
    }

    set width(value: number) {
        this.container.width = value;
    }

    get height(): number {
        return this.container.height;
    }

    set height(value: number) {
        this.container.height = value;
    }

    get tint(): number {
        return this.container.tint;
    }

    set tint(value: number) {
        this.container.tint = value;
    }
}
